module.exports = new __parcel__URL__("empty-cannot-load-item-darkmode.2b4e73cc.svg").toString();